import { render, staticRenderFns } from "./new-dept-selector.vue?vue&type=template&id=43d59fc5&scoped=true&"
import script from "./new-dept-selector.vue?vue&type=script&lang=js&"
export * from "./new-dept-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d59fc5",
  null
  
)

export default component.exports